// extracted by mini-css-extract-plugin
export default {"container":"ChoiceQuestionFinishedScreenForZoom_container__FDsqm","questionText":"ChoiceQuestionFinishedScreenForZoom_questionText__SEqmv"};